export default "<button>\r\n  <span text>\r\n    <ng-content></ng-content>\r\n  </span>\r\n  <ion-icon [name]=\"icon\"></ion-icon>\r\n</button>";